import React, { useState, lazy, Suspense } from 'react'
import { GeneralSchema } from '@ashleynexvelsolutions/general-schema'
import { HeaderV10 } from '@ashleynexvelsolutions/header-v10'
import {
  GeneralSchemaFunction,
  HeaderFunction,
  FooterFunction,
  BackToTopFunction,
  MultiStepFormFunction,
} from '../DataImports'

const Portal = lazy(() =>
  import('@ashleynexvelsolutions/portal').then(module => ({
    default: module.Portal,
  })),
)
const MultiStepFormV7 = lazy(() =>
  import('@ashleynexvelsolutions/multi-step-form-v7').then(module => ({
    default: module.MultiStepFormV7,
  })),
)

const FooterV10 = lazy(() =>
  import('@ashleynexvelsolutions/footer-v10').then(module => ({
    default: module.FooterV10,
  })),
)
const BackToTopV3 = lazy(() =>
  import('@ashleynexvelsolutions/back-to-top-v3').then(module => ({
    default: module.BackToTopV3,
  })),
)

const Layout = ({ children }) => {
  // eslint-disable-next-line no-unused-vars
  const [formModal, setFormModal] = useState(false)

  const handleButton = () => setFormModal(true)
  return (
    <div className="bg-white">
      <div className="max-w-[160rem] mx-auto">
        <HeaderV10 {...HeaderFunction(handleButton)} />
        {children}
        <Suspense fallback="loading">
          <FooterV10 {...FooterFunction()} />
        </Suspense>
        <Suspense fallback="loading">
          <BackToTopV3 {...BackToTopFunction()} />
        </Suspense>
        <Suspense fallback="loading">
          {formModal === true && (
            <Portal
              isOpen
              onClose={() => setFormModal(false)}
              xColor="text-blue"
              maxWidth="max-w-full"
              padding="p-0"
              width="w-full lg:w-auto"
              background="bg-white/[0.9]"
            >
              <MultiStepFormV7 {...MultiStepFormFunction()} />
            </Portal>
          )}
        </Suspense>
        <GeneralSchema {...GeneralSchemaFunction()} />
      </div>
    </div>
  )
}
export { Layout }
